
// General mote handling class that is a thin wrapper around the object data returned by our API.
// The main usage of this is to provide a unified interface for handling more complicated operations dealing with relationships and payload hydrating, etc.
// In general the Field class is used more for handling data processing, e.g. date parsing or attachments, since they deal with specific data - but
// relationships are general to the mote itself despite being also 'fields' stored in payload.

import { SchemaCache } from '@/schemas';

class Mote {
    id = 0;
    group_id = 0;
    type_id = 0;
    payload = {};
    sequence = 0;
	
    // Constructor for loading mote object from server data.
    constructor(record) {
        // Load basic fields only.
        for (let key in record) {
            if (key in this && key != 'payload') this[key] = record[key];
        }
        // Load payload separately, parsing it for relationship fields.
        this.payload = record.payload || {};
        for (let field of this.getMoteFields()) {
            if (field.fieldtype == 'relationship') {
                this.replaceRelationshipPayload(field);
            }
        }
    }

    getMoteSchema() {
        return SchemaCache.getSchemaById(this.type_id);
    }
    getMoteFields() {
        return this.getMoteSchema()?.fields ?? [];
    }

    replaceRelationshipPayload(field) {
        console.log("field", field);
        // this.payload[field.field] = {};
    }

    moteTitle() {
        if (!this.payload)
            return '#' + this.id;
        return this.payload.title || this.payload.name || ('#' + this.id);
    }
    
    moteValues() {
        return {
			...(this.payload || {}),
			...{
                id: this.id,
                group_id: this.group_id,
                type_id: this.type_id,
                sequence: this.sequence,
            }
		};
    }
}



export { Mote };
